import styled from 'styled-components';

interface ModalProps {
  isVisible: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  height: 100%;
  background-color: ${({ theme }) => theme.background};

  @media (min-width: 996px) {
    > p {
      display: none;
    }
  }

  @media (max-width: 996px) {
    height: calc(100vh - 122px);
    width: 100vw;

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      width: 100%;
      color: #fff;
      margin-top: auto;

      svg {
        margin-left: 8px;
        transform: rotateX(180deg);
      }
    }
  }

  @media (max-width: 700px) {
    height: calc(100vh - 114px);
  }
`;

export const Rules = styled.section<ModalProps>`
  position: absolute;
  z-index: 9;
  height: calc(100vh - 57px);
  width: calc(100vw - 200px);
  background-color: ${({ theme }) => theme.backgroundRGBA};
  display: ${(props) => (props.isVisible ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  @media (max-width: 996px) {
    height: calc(100vh - 114px);
    width: 100vw;
  }

  div {
    background: ${({ theme }) => theme.backgroundRGBA};
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    color: ${({ theme }) => theme.text};
    width: 65%;
    padding: 30px 20px;
    border-radius: 5px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-x: hidden;
    border: 2px solid ${({ theme }) => theme.text};

    @media (max-width: 1000px) {
      width: 70%;
    }

    @media (max-width: 850px) {
      width: 75%;
    }

    @media (max-width: 700px) {
      width: 80%;
    }

    @media (max-width: 600px) {
      width: 90%;
    }

    ::-webkit-scrollbar {
      display: none;
    }

    header {
      text-align: center;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0;
      margin: 0;

      button {
        border: none;
        outline: none;
        background-color: transparent;
        margin: 0;
        padding: 0;
        margin-top: -30px;
      }
    }

    h1 {
      font-size: 2.1rem;
      color: ${({ theme }) => theme.text};
      margin: 0;
      padding: 0;
    }

    footer {
      text-align: center;
    }

    main {
      overflow-y: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;
      text-align: justify;
    }

    main::-webkit-scrollbar {
      display: none;
    }

    span {
      font-size: 1.5rem;
      color: ${({ theme }) => theme.text};
      letter-spacing: 0.05rem;

      strong {
        letter-spacing: 0.09rem;
      }
    }
  }
`;

export const GameContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (min-width: 996px) {
    &::before {
      content: '';
      width: 100%;
      height: 1.25rem;
      background: #9fa7f7;
    }
  }

  @media (max-width: 996px) {
    margin-top: 1rem;
  }

  > div {
    display: flex;
  }
`;
